import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import styled from "styled-components";
import IconWithTextList from "../../components/common/IconWithTextList";
import CartTable from "../../components/cart/CartTable";
import CartOrderSummary from "../../components/cart/CartOrderSummary";
import CollapsibleCart from "../../components/cart/CollapsibleCart";
import { useRequest } from "../../hooks/useRequest";
import { useAuth } from "../../hooks/useAuth";
import Button from "../../components/common/Button";
import { useAppContext } from "../../context/useAppContext";
import { formatStoreName } from "../../utils/helper";

const CartStyle = styled.div`
  padding-top: 70px;
  background: #fff;
  min-height: 100vh;

  .page__title {
    color: #303030;
    font-size: 42px;
    font-weight: 700;
    line-height: 51px;
    margin-bottom: 20px;
    text-align: left;
  }

  .cart__wrapper {
    display: flex;
    gap: 15px;
    margin-bottom: 32px;
  }

  .seller-tabs {
    display: flex;
    border-bottom: 2px solid #e5e7eb;
    margin-bottom: 24px;
    background: white;
    border-radius: 8px 8px 0 0;
    overflow-x: auto;
    scrollbar-width: none;
    -ms-overflow-style: none;
  }

  .seller-tabs::-webkit-scrollbar {
    display: none;
  }

  .seller-tab {
    background: transparent;
    border: none;
    border-bottom: 3px solid transparent;
    padding: 16px 24px;
    cursor: pointer;
    transition: all 0.3s ease;
    white-space: nowrap;
    min-width: fit-content;
    display: flex;
    align-items: center;
    gap: 12px;
    position: relative;
    font-size: 14px;
    font-weight: 500;
    color: #6b7280;
  }

  .seller-tab:hover {
    background: #f9fafb;
    color: #374151;
  }

  .seller-tab.active {
    background: #fef2f2;
    border-bottom-color: #ae0000;
    color: #ae0000;
    font-weight: 600;
  }

  .seller-tab-avatar {
    width: 28px;
    height: 28px;
    border-radius: 50%;
    background: #f3f4f6;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 600;
    font-size: 12px;
    color: #6b7280;
  }

  .seller-tab.active .seller-tab-avatar {
    background: #ae0000;
    color: white;
  }

  .seller-tab-info h4 {
    margin: 0;
    font-size: 14px;
    font-weight: inherit;
  }

  .seller-tab-info p {
    margin: 0;
    font-size: 11px;
    opacity: 0.7;
  }

  .selected-seller-cart {
    background: white;
    border-radius: 0 0 12px 12px;
    box-shadow: 0px 4px 6px -1px rgba(0, 0, 0, 0.1);
    overflow: hidden;
    border: 1px solid #e5e7eb;
    border-top: none;
  }

  .seller-cart-container {
    background: white;
    border-radius: 7.5px;
    box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.2);
    overflow: hidden;
    border: 0.75px solid rgba(48, 48, 48, 0.25);
  }

  .seller-header {
    background: #ae0000;
    color: white;
    padding: 20px 24px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
    transition: all 0.3s ease;
  }

  .seller-header:hover {
    background: #880202;
  }

  .seller-info {
    display: flex;
    align-items: center;
    gap: 12px;
  }

  .seller-avatar {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.2);
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 600;
    font-size: 16px;
    position: relative;
    overflow: hidden;
  }

  .seller-avatar::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(
      45deg,
      rgba(255, 255, 255, 0.1),
      rgba(255, 255, 255, 0.3)
    );
    border-radius: 50%;
  }

  .seller-avatar span {
    position: relative;
    z-index: 1;
  }

  .seller-details h3 {
    margin: 0;
    font-size: 18px;
    font-weight: 600;
  }

  .seller-details p {
    margin: 0;
    font-size: 14px;
    opacity: 0.9;
  }

  .header-actions {
    display: flex;
    align-items: center;
    gap: 12px;
  }

  .collapse-btn {
    background: rgba(255, 255, 255, 0.2);
    border: 0.75px solid rgba(255, 255, 255, 0.3);
    color: white;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.3s ease;
    font-size: 16px;
    font-weight: bold;
  }

  .collapse-btn:hover {
    background: rgba(255, 255, 255, 0.3);
    transform: scale(1.1);
  }

  .cart-content {
    padding: 24px;
    transition: all 0.3s ease;
    overflow: hidden;
    max-height: 1000px;
    opacity: 1;
    display: block;
  }

  .cart-content.collapsed {
    padding: 0 24px;
    max-height: 0;
    opacity: 0;
    display: none;
  }

  .cart-content {
    padding: 24px;
  }

  .empty-cart-message {
    text-align: center;
    padding: 60px 20px;
    color: rgba(48, 48, 48, 0.5);
  }

  .empty-cart-message h3 {
    font-size: 20px;
    margin-bottom: 8px;
    color: #303030;
    font-weight: 600;
  }

  .empty-cart-message p {
    font-size: 16px;
    margin-bottom: 24px;
  }

  .icon__with__text {
    margin-top: 60px;
  }

  .instabuild-section {
    margin-top: 60px;
  }

  .instabuild-title {
    color: #303030;
    font-size: 42px;
    font-weight: 700;
    line-height: 51px;
    margin-bottom: 20px;
    text-align: left;
  }

  .coming-soon-badge {
    margin-left: 12px;
    font-size: 12px;
    color: #ae0000;
    background-color: #fbe4e4;
    padding: 4px 8px;
    border-radius: 7.5px;
    font-weight: 600;
    border: 0.75px solid #ae0000;
  }

  @media (max-width: 768px) {
    padding-top: 30px;

    .page__title {
      font-size: 24px;
      line-height: 32px;
      margin-bottom: 24px;
    }

    .cart__wrapper {
      flex-direction: column;
      gap: 16px;
    }

    .seller-tabs {
      margin-bottom: 16px;
      border-radius: 6px 6px 0 0;
    }

    .seller-tab {
      padding: 12px 16px;
      min-width: 120px;
      font-size: 13px;
    }

    .seller-tab-avatar {
      width: 24px;
      height: 24px;
      font-size: 11px;
    }

    .seller-tab-info h4 {
      font-size: 13px;
    }

    .seller-tab-info p {
      font-size: 10px;
    }

    .selected-seller-cart {
      border-radius: 0 0 8px 8px;
    }

    .seller-header {
      padding: 16px 20px;
      flex-direction: column;
      gap: 12px;
      align-items: flex-start;
    }

    .seller-info {
      width: 100%;
    }

    .cart-content {
      padding: 20px;
    }

    .instabuild-title {
      font-size: 24px;
      line-height: 32px;
      margin-bottom: 24px;
    }
  }
`;

const MissingCartItems = styled.div`
  background: white;
  border-radius: 7.5px;
  box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.2);
  max-width: 500px;
  margin: 60px auto;
  padding: 60px 40px;
  text-align: center;
  border: 0.75px solid rgba(48, 48, 48, 0.25);

  .title {
    font-size: 18px;
    font-weight: 500;
    color: #303030;
    margin-bottom: 12px;
  }

  .subtitle {
    font-size: 14px;
    color: rgba(48, 48, 48, 0.5);
    margin-bottom: 32px;
    line-height: 1.5;
  }

  button {
    padding: 12px 30px;
    border-radius: 7.5px;
    background: #ae0000;
    color: white;
    border: none;
    font-weight: 700;
    font-size: 15px;
    cursor: pointer;
    transition: all 0.3s ease;

    &:hover {
      background: #880202;
    }
  }

  .empty_cart {
    width: 300px;
    display: block;
    margin: -30px auto 0;
  }
`;

const Cart = () => {
  const [getCart, { isLoading: isFetchingCarts }] = useRequest();
  const auth = useAuth();
  const { setIsAuthForm, setCartItemNumber } = useAppContext();
  const [isQtyChanged, setIsQtyChanged] = useState(false);
  const [cartData, setCartData] = useState([]); // Changed to array for multiple carts
  const [collapsedCarts, setCollapsedCarts] = useState(new Set()); // Track collapsed cart IDs - empty set means all carts are open by default
  const [selectedSellerId, setSelectedSellerId] = useState(null); // Track selected seller for tab view

  // Function to switch active cart
  const switchActiveCart = async (cartId) => {
    try {
      const response = await getCart({
        path: `/cart/switch/${cartId}`,
        method: "POST",
      });
      if (response.success) {
        // Refresh cart data
        setIsQtyChanged((prev) => !prev);
      }
    } catch (error) {
      console.error("Error switching cart:", error);
    }
  };

  // Function to handle cart clearing and auto-switch to next cart
  const handleCartCleared = (clearedCartId) => {
    // Find the next available cart
    const remainingCarts = cartData.filter(
      (cart) => cart._id !== clearedCartId
    );

    if (remainingCarts.length > 0) {
      // Switch to the first remaining cart
      const nextCartId = remainingCarts[0]._id;
      setSelectedSellerId(nextCartId);
      switchActiveCart(nextCartId);
    } else {
      // No carts left, reset selected seller
      setSelectedSellerId(null);
    }
  };

  // Function to toggle cart collapse/expand
  const toggleCartCollapse = (cartId) => {
    setCollapsedCarts((prev) => {
      const newSet = new Set(prev);
      if (newSet.has(cartId)) {
        newSet.delete(cartId); // Remove from collapsed set (expand)
        console.log(`Expanding cart: ${cartId}`);
      } else {
        newSet.add(cartId); // Add to collapsed set (collapse)
        console.log(`Collapsing cart: ${cartId}`);
      }
      return newSet;
    });
  };

  console.log("++++++++cartData++++++++", cartData);
  console.log("++++++++collapsedCarts++++++++", collapsedCarts);
  const [instacartData, setInstacartData] = useState([]);
  const [isCheckoutButtonDisabled, setIsCheckoutButtonDisabled] =
    useState(true);
  const location = useLocation();

  const calculateTotalWithVariations = (item) => {
    // Check if item and item.product exist
    if (!item || !item.product) {
      console.error("Invalid item or missing product data");
      return 0;
    }

    // Get base price, calculating discount if applicable
    let basePrice;
    const product = item.product;
    const price = Number(product.price || 0);
    const discount = Number(product.discount || 0);
    const discountType = product.discountType; // Assuming 'flat' or 'percentage'

    if (discount > 0 && price > 0) {
      // Ensure price is positive before applying discount
      if (discountType === "flat") {
        basePrice = price - discount;
      } else if (discountType === "percentage") {
        basePrice = price - (price * discount) / 100;
      } else {
        // Fallback for unknown discount type: use original price
        console.warn(
          `Unknown or missing discount type: ${discountType}. Using original price.`
        );
        basePrice = price;
      }
      // Ensure basePrice doesn't go below zero
      basePrice = Math.max(0, basePrice);
    } else {
      // No discount or zero price, use the original price
      basePrice = price;
    }

    // Parse variations if they exist
    try {
      // Ensure item.variation is a string before parsing
      const variationString =
        typeof item.variation === "string" ? item.variation : "[]";
      const variations = JSON.parse(variationString);
      const variationPrice = variations.reduce((sum, variation) => {
        return sum + Number(variation?.price || 0);
      }, 0);

      // Calculate total including variations and quantity
      return (basePrice + variationPrice) * (item.quantity || 1);
    } catch (error) {
      console.error(
        "Error parsing variations:",
        error,
        "Raw variation data:",
        item.variation
      );
      // Fallback calculation if variations fail to parse
      return basePrice * (item.quantity || 1);
    }
  };

  useEffect(() => {
    // Hydrate from preloaded carts passed via navigation state (optimistic render)
    const pre = location?.state?.preloadedCarts;
    if (Array.isArray(pre) && pre.length > 0) {
      setCartData(pre);
      if (!selectedSellerId) {
        setSelectedSellerId(pre[0]._id);
      }
    }

    const fetchCarts = async () => {
      try {
        const path = `/cart/all?limit=20&page=1`;
        const response = await getCart({ path });
        console.log("Raw API Response:", response);

        if (response.success) {
          setCartItemNumber(0);
          let regularCarts = [];
          let instabuildCarts = [];

          console.log("Processing carts:", response.data);

          response.data.forEach((item, index) => {
            console.log(`Processing cart ${index}:`, {
              id: item._id,
              isInstabuild: item.isInstabuild,
              itemsCount: item.items?.length,
              items: item.items,
              sellerId: item.sellerId,
            });

            // Calculate total items for cart count
            item?.items?.forEach((cartItem) => {
              setCartItemNumber((prev) => prev + cartItem?.quantity);
            });

            // Process cart items with variations
            const processedCart = {
              ...item,
              items: item.items.map((cartItem) => ({
                ...cartItem,
                totalPrice: calculateTotalWithVariations(cartItem),
                variation: cartItem.variation ? cartItem.variation : [],
              })),
            };

            // Separate regular and instabuild carts
            if (item?.isInstabuild) {
              instabuildCarts.push(processedCart);
              console.log("Added to instabuild carts:", processedCart._id);
            } else {
              // Add all regular carts (seller-wise carts)
              if (item.items.length > 0) {
                regularCarts.push(processedCart);
                console.log(
                  "Added to regular carts:",
                  processedCart._id,
                  "Seller:",
                  processedCart.sellerId
                );
              } else {
                console.log("Skipped empty regular cart:", item._id);
              }
            }
          });

          // Update state with processed carts
          setCartData(regularCarts || []);
          if (instabuildCarts.length > 0) {
            setInstacartData(instabuildCarts);
          }

          // Set first seller as selected for tab view
          if (regularCarts && regularCarts.length > 0) {
            // If no seller is selected or the selected seller no longer exists, select the first one
            if (
              !selectedSellerId ||
              !regularCarts.find((cart) => cart._id === selectedSellerId)
            ) {
              setSelectedSellerId(regularCarts[0]._id);
            }
          } else {
            // No carts available, reset selected seller
            setSelectedSellerId(null);
          }

          setIsCheckoutButtonDisabled((regularCarts || []).length === 0);
        } else {
          // Handle error case
          console.error("Failed to fetch carts:", response);
          setCartData([]);
          setInstacartData([]);
          setIsCheckoutButtonDisabled(true);
        }
      } catch (error) {
        console.error("Error fetching carts:", error);
        setCartData([]);
        setInstacartData([]);
        setIsCheckoutButtonDisabled(true);
      }
    };

    fetchCarts();
    // eslint-disable-next-line
  }, [isQtyChanged]);

  if (!auth) {
    return (
      <MissingCartItems>
        <img
          src="/images/empty_cart.png"
          className="empty_cart"
          alt="Empty Cart"
        />
        <h2 className="title">Missing Cart items?</h2>
        <p className="subtitle">Login to see the items you added previously</p>
        <Button title={"Login"} onClick={() => setIsAuthForm(true)} />
      </MissingCartItems>
    );
  }

  return (
    <CartStyle>
      <div className="container">
        <div className="page__title">Your Cart</div>

        {isFetchingCarts && (!cartData || cartData.length === 0) ? (
          <div className="seller-cart-container">
            <div className="empty-cart-message">
              <h3>Loading cart...</h3>
              <p>Please wait while we load your items.</p>
            </div>
          </div>
        ) : cartData && cartData.length > 0 ? (
          <>
            {/* Seller Tabs */}
            <div className="seller-tabs">
              {cartData.map((sellerCart, index) => {
                const cartNumber = index + 1;
                const isActive = selectedSellerId === sellerCart._id;

                return (
                  <div
                    key={sellerCart._id}
                    className={`seller-tab ${isActive ? "active" : ""}`}
                    onClick={() => setSelectedSellerId(sellerCart._id)}
                  >
                    <div className="seller-tab-avatar">
                      <span>{cartNumber}</span>
                    </div>
                    <div className="seller-tab-info">
                      <h4>
                        {formatStoreName(
                          sellerCart.sellerId?.name ||
                          sellerCart.items?.[0]?.product?.seller?.name
                        )}
                      </h4>
                      <p>
                        {sellerCart.items?.length} item
                        {sellerCart.items?.length !== 1 ? "s" : ""}
                      </p>
                    </div>
                  </div>
                );
              })}
            </div>

            {/* Selected Seller's Cart */}
            {selectedSellerId && (
              <div className="selected-seller-cart">
                {(() => {
                  const selectedCart = cartData.find(
                    (cart) => cart._id === selectedSellerId
                  );
                  if (!selectedCart) return null;

                  return (
                    <div className="seller-cart-container">
                      <div className="seller-header">
                        <div className="seller-info">
                          <div className="seller-avatar">
                            <span>
                              {cartData.findIndex(
                                (cart) => cart._id === selectedSellerId
                              ) + 1}
                            </span>
                          </div>
                          <div className="seller-details">
                            <h3>
                              {formatStoreName(
                                selectedCart.sellerId?.name ||
                                selectedCart.items?.[0]?.product?.seller?.name
                              )}
                            </h3>
                            <p>
                              {selectedCart.items?.length} item
                              {selectedCart.items?.length !== 1 ? "s" : ""} in
                              cart
                            </p>
                          </div>
                        </div>
                      </div>

                      <div className="cart-content">
                        <div className="cart__wrapper">
                          <CartTable
                            loading={isFetchingCarts}
                            cartData={selectedCart?.items}
                            setIsQtyChanged={setIsQtyChanged}
                            setIsCheckoutButtonDisabled={
                              setIsCheckoutButtonDisabled
                            }
                            cartId={selectedCart?._id}
                            calculateTotalWithVariations={
                              calculateTotalWithVariations
                            }
                            setCartData={setCartData}
                            onCartCleared={handleCartCleared}
                          />

                          {selectedCart?.items?.length > 0 && (
                            <div className="cart__order__summary__hodler">
                              <CartOrderSummary
                                isCheckoutButtonDisabled={
                                  isCheckoutButtonDisabled
                                }
                                isQtyChanged={isQtyChanged}
                                cartData={selectedCart}
                              />
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  );
                })()}
              </div>
            )}
          </>
        ) : (
          <div className="seller-cart-container">
            <div className="empty-cart-message">
              <h3>Your cart is empty</h3>
              <p>Add some products to get started with your shopping</p>
            </div>
          </div>
        )}

        <div className="instabuild-section">
          <div className="instabuild-title">
            Instabuild Pro Cart
            <span className="coming-soon-badge">Coming Soon</span>
          </div>

          {instacartData?.length > 0 ? (
            instacartData?.map((item, index) => {
              const isCollapsed = collapsedCarts.has(item._id);
              const instabuildNumber = index + 1; // Show 1, 2, 3, etc. for Instabuild projects

              return (
                <div key={item?._id} className="seller-cart-container">
                  <div
                    className="seller-header"
                    onClick={() => toggleCartCollapse(item._id)}
                  >
                    <div className="seller-info">
                      <div className="seller-avatar">
                        <span>I{instabuildNumber}</span>
                      </div>
                      <div className="seller-details">
                        <h3>{item?.name}</h3>
                        <p>Instabuild Project</p>
                      </div>
                    </div>
                    <div className="header-actions">
                      <button
                        className={`collapse-btn ${isCollapsed ? "collapsed" : ""
                          }`}
                        onClick={(e) => {
                          e.stopPropagation();
                          toggleCartCollapse(item._id);
                        }}
                      >
                        {isCollapsed ? "▲" : "▼"}
                      </button>
                    </div>
                  </div>
                  <div
                    className={`cart-content ${isCollapsed ? "collapsed" : ""}`}
                  >
                    <CollapsibleCart
                      loading={isFetchingCarts}
                      title={item?.name}
                      cartData={item}
                      isCheckoutButtonDisabled={isCheckoutButtonDisabled}
                      isQtyChanged={isQtyChanged}
                      setIsQtyChanged={setIsQtyChanged}
                      setIsCheckoutButtonDisabled={setIsCheckoutButtonDisabled}
                      instabuildId={item?.isInstabuild ? item?._id : ""}
                      setCartData={setCartData}
                    />
                  </div>
                </div>
              );
            })
          ) : (
            <div className="seller-cart-container">
              <div className="empty-cart-message">
                <h3>No Instabuild projects yet</h3>
                <p>Create your first Instabuild project to get started</p>
              </div>
            </div>
          )}
        </div>
      </div>
      <div className="icon__with__text">
        <IconWithTextList />
      </div>
    </CartStyle>
  );
};

export default Cart;
